<template>
    <div>
        <rkm-form ref="Form">
            <rkm-tabs v-model="tabIndex">

                <rkm-tab
                    title="AGENDAR EXAMES"
                    @click.prevent="setActive('InclusaoAgendamento')"
                >
                    <tab-agendar-exames
                        ref="TabAgendarExames"
                        :data="{form, model}"
                        :feriado="form.feriados"
                        :agendamento="agendamento"
                        :diasCalendario="diasCalendario"
                        :index="index"
                        :vagas="vagas"
                        :jornadas="jornadas"
                        :vagasPreenchidas="vagasPreenchidas"
                        :horaSave="horaSave"
                        :unidadeExecutante="unidadeExecutante"
                        :grupo="grupo"
                        :profissional="profissional"
                        :regulacao-solicitacao="regulacaoSolicitacao"
                        :exames-ambulatorio="examesAmbulatorio"
                        :multiple-exames-ambulatorio="multipleExamesAmbulatorio"
                        @setFields="setFields"
                        @loadInfraestrutura="loadInfraestrutura"
                        @loadDiasCalendario="loadDiasCalendario"
                        @resetProfissional="resetProfissional"
                        @resetGrupoExame="resetGrupoExame"
                        @loadVagas="loadVagas"
                        @alterCalendar="alterCalendar"
                        @loadGrupo="loadGrupo"
                        @loadProfissional="loadProfissional"
                        @agendarAmbulatorioAtendimento="agendarAmbulatorioAtendimento"
                        @multipleAmbulatorioAtendimento="multipleAmbulatorioAtendimento"
                    />
                </rkm-tab>

                <rkm-tab
                    v-if="!hideAgendamentos"
                    title="EXAMES AGENDADOS"
                    @click.prevent="setActive('agendamentosCadastradas')"
                >
                    <tab-exames-agendados
                        ref="TabExamesAgendados"
                        :data="{form, model}"
                        @handleAlter="handleAlter"
                        @loadDays="loadDays"
                    />
                </rkm-tab>

                <rkm-tab
                    v-if="!hideAgendamentos"
                    title="EXAMES CANCELADOS"
                    @click.prevent="setActive('agendamentosCancelados')"
                >
                    <tab-exames-cancelados
                        ref="TabExamesCancelados"
                        :data="{form, model}"
                    />
                </rkm-tab>

                <rkm-tab
                    v-if="!hideAgendamentos"
                    title="EXAMES EXCLUÍDOS"
                    @click.prevent="setActive('agendamentosExcluidos')"
                >
                    <tab-exames-excluidos
                        ref="TabExamesExcluidos"
                        :data="{form, model}"
                    />
                </rkm-tab>
            </rkm-tabs>
        </rkm-form>

        <ModalSupervisor
            origem='save'
            @saveModal="saveModal"
            ref="ModalSupervisor"
        />
    </div>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

//Moment
import moment from 'moment'

// Enuns.
import modulo from '@/enums/cadastro/feriado/modulo'
import abrangencia from '@/enums/cadastro/feriado/abrangencia'
import tipoControleJornada from '@/enums/exame-imagem/tipoControleJornada'
import status from '@/enums/exame-imagem/fechamento/status'
import statusJornada from '@/enums/exame-imagem/statusJornada'

// Mixins.
import { formats, permissao, repository, stringCase, object, error, data, printExameImagem } from '@/mixins'

// Components.
import TabExamesAgendados from '@/components/exame-imagem/agendamento/tabs/agendados/Index'
import TabAgendarExames from '@/components/exame-imagem/agendamento/tabs/cadastro/Form'
import TabExamesExcluidos from '@/components/exame-imagem/agendamento/tabs/excluidos/Index'
import TabExamesCancelados from '@/components/exame-imagem/agendamento/tabs/cancelados/Index'
import ModalSupervisor from '@/components/exame-imagem/agendamento/tabs/cadastro/components/permissao/Modal'

export default {
    components: {
        TabExamesAgendados,
        TabAgendarExames,
        TabExamesExcluidos,
        TabExamesCancelados,
        ModalSupervisor
    },
    computed: {
        unidadeExecutante(){

            return this.form.unidadeExecutante ? this.form.unidadeExecutante : []
        },
        isFromRegulacao() {

            return !!this.regulacaoSolicitacao
        }
    },
    created() {
        this.repositories = {
            agendamento: this.getConectaSusRepository('exameImagem.agendamento'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
        },
        this.load()
    },
    data: () => ({
        saving: false,
        additionals: null,
        form: {},
        model: {
            cadastro: [],
            inclusao: [],
            medicoSolicitante: null,
            pacienteId: null,
        },
        feriado: {},
        tabIndex: 0,
        index: null,
        paciente: {
            cidadao:[]
        },
        vagas: [],
        jornadas: [],
        vagasPreenchidas: 0,
        horaSave: null,
        agendamento: {
            alterar: false,
            retroativo: false,
            agendamentoNumero: '',
            impressao: true,
            data: null,
            dataTradada: null,
            dataMenstruacao: null,
            horaInicial: null,
            grupoExameId: null,
            grupoExameNome: '',
            exames: [],
            gestante: false,
            horaExame: '',
            jornadaId: null,
            controleJornadaId: null,
            infraestruturaId: null,
            infraestruturaNome: '',
            agendamentoId: null,
            unidadeId: null,
            unidadeNome: '',
            profissionalNome: '',
            profissionalId: null,
            prestadorId: null,
            unidadeDisabled: false,
            usuarioId: '',
            unidadeNomeSolicitante: '',
            unidadeSolicitanteId: null,
            infraestruturaSolicitanteId: null,
            observacao: '',
            usuarioNome: '',
            selecionado: false,
            urgente: false,
            pacienteId: '',
            sexoId: '',
            medicoSolicitante: null,
            medicoNome: '',
            medicoId: null,
            nomeResponsavel: '',
            incluido: [],
            supervisorId: null,
            cotasPrestadores: [],
            agendadorId: null,
        },
        enums: {
            modulo,
            abrangencia,
            tipoControleJornada,
            status,
            statusJornada
        },
        diasCalendario: [],
        dataInformada: '',
        grupo: [],
        profissional: [],
        examesAmbulatorio: [],
        multipleExamesAmbulatorio: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading', 'unsetShowExitFormConfirmation']),
        load() {

            this.setLoading()

            this.repositories.agendamento.show(this.id)
                .then(({ data }) => {

                    if (data.additionals.enderecoDesatualizadoBloqueado) {

                        this.unsetShowExitFormConfirmation()

                        this.showAlert(
                            'O endereço do paciente ainda não foi atualizado pela Base Nacional. Atualize o cadastro para continuar.',
                            'Atenção'
                        )

                        this.$router.push({ name: 'exame-imagem-agendamento-index' })

                        return
                    }

                    const exibirExameAmbulatorioAtendimento = data.form.exibirExameAmbulatorioAtendimento

                    data.form.exibirExameAmbulatorioAtendimento = false

                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model

                    this.loadPaciente(data.form.paciente, exibirExameAmbulatorioAtendimento)

                    this.paciente.cidadao.idade = data.form.paciente.cidadao.idade.anos

                    if (data.form.paciente.cidadao.idade.anos < 18 || data.form.paciente.cidadao.idade.anos >= 60) {

                        this.agendamento.nomeResponsavel = data.form.paciente.cidadao.nomeMae
                    }

                    this.agendamento.unidadeSolicitanteId  = data.form.unidadeLogada
                    this.agendamento.infraestruturaSolicitanteId  = data.form.localAtendimentoLogado

                    this.$nextTick().then(() => {

                        this.tabRefs = [
                            this.$refs.TabExamesAgendados,
                            this.$refs.TabAgendarExames,
                            this.$refs.TabExamesCancelados,
                            this.$refs.TabExamesExcluidos,
                        ]

                        if (this.isFromRegulacao) {

                            const preencherMedicoSolicitanteFromRegulacao = () => {

                                this.agendamento.medicoSolicitante = {
                                    id: this.regulacaoSolicitacao.usuarioSolicitanteId,
                                    cidadaoNome: this.regulacaoSolicitacao.usuarioSolicitanteNome,
                                    nome: this.regulacaoSolicitacao.usuarioSolicitanteNome,
                                }

                                this.agendamento.urgente = this.regulacaoSolicitacao.isUrgente
                            }

                            if (!this.regulacaoSolicitacao.exameImagemAgendamentoId) {

                                preencherMedicoSolicitanteFromRegulacao()

                                return
                            }

                            const itemAgendamento = this.model.agendamentos
                                .find(a => String(a.agendamentoId) === String(this.regulacaoSolicitacao.exameImagemAgendamentoId))

                            if (itemAgendamento) {

                                this.handleAlter(itemAgendamento, this.model.agendamentos.indexOf(itemAgendamento))

                                return
                            }

                            preencherMedicoSolicitanteFromRegulacao()
                        }
                    })

                    this.$emit('loaded', {additionals: this.additionals, form: this.form})
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setFields(field) {

            if (field == 'unidadeExecutante') {

                this.agendamento.infraestruturaId = null
                this.agendamento.grupoExameId = null
                this.agendamento.profissionalId = null

                let infraestruturaPrincipal = this.form.unidadeExecutante.find(u =>
                    u.unidadeId === this.agendamento.unidadeId)

                if(infraestruturaPrincipal){

                    this.loadInfraestrutura(infraestruturaPrincipal.infraestruturas)
                }

                if (this.agendamento.infraestruturaId) {

                    this.loadGrupo()
                }
            } else if (field == 'infraestruturaId') {

                this.agendamento.grupoExameId = null
                this.agendamento.profissionalId = null

                if (this.agendamento.infraestruturaId) {

                    this.loadGrupo()
                }

            } else if (field == 'grupoExameId') {

                this.agendamento.profissionalId = null

                if (this.agendamento.grupoExameId) {

                    this.loadProfissional()
                }

            } else if (field == 'profissionalId' || this.agendamento.profissionalId){

                this.loadVagas()
            }

            if (field !== 'unidadeExecutante' && field !== 'infraestruturaId') {

                this.loadDays()
            }
        },
        loadInfraestrutura(infraestrutura) {

            const infraestruturaPrincipal = infraestrutura.find(u => u.principal)

            if (infraestruturaPrincipal) {
                this.agendamento.infraestruturaId = infraestruturaPrincipal.infraestruturaId;
            }

        },
        loadGrupo(){

            this.setLoading()

                this.repositories.agendamento.getGrupo({
                    unidade_id: this.agendamento.unidadeId,
                    infraestrutura_id: this.agendamento.infraestruturaId,
                })
               .then(({ data }) => {

                    this.grupo = data

                    if (this.isFromRegulacao) {

                        this.grupo = this.grupo.filter(g => g.exameId === this.regulacaoSolicitacao.itens[0].exame.grupoTipoId)

                        if (this.grupo.length > 0) {

                            this.agendamento.grupoExameId = this.regulacaoSolicitacao.itens[0].exame.grupoTipoId

                            this.setFields('grupoExameId')
                        }
                        else {

                            this.showWarningNotification('O grupo do exame regulado não está disponível para a unidade '
                                + 'e local de atendimento executantes selecionados.')
                        }
                    } else if (this.examesAmbulatorio.length > 0) {

                        this.grupo = this.grupo.filter(g => g.exameId === this.examesAmbulatorio[0].grupoId)

                        if (this.grupo.length > 0) {

                            this.agendamento.grupoExameId = this.examesAmbulatorio[0].grupoId

                            this.setFields('grupoExameId')
                        }
                        else {

                            this.showWarningNotification('O grupo do(s) exame(s) não está disponível para a unidade '
                                + 'e local de atendimento executantes selecionados.')
                        }
                    } else {

                        if (this.agendamento.grupoExameId) {

                            const existe = this.grupo.find(g => g.exameId === this.agendamento.grupoExameId)

                            if (!existe) {

                                this.agendamento.grupoExameId = null

                                this.showWarningNotification('O grupo de exame não está disponível para a unidade '
                                    + 'e local de atendimento executantes selecionados.')
                            }
                        } else {

                            const grupoExameId = this.grupo.length === 1 ? this.grupo[0].exameId : null

                            this.agendamento.grupoExameId = grupoExameId
                        }
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadProfissional(){

            this.setLoading()

                this.repositories.agendamento.getProfissional({
                    unidade_id: this.agendamento.unidadeId,
                    infraestrutura_id: this.agendamento.infraestruturaId,
                    exame_id: this.agendamento.grupoExameId,
                    infraestrutura_prestadora_id: this.isFromRegulacao
                        ? this.regulacaoSolicitacao.prestador.infraestruturaId
                        : null
                })
               .then(({ data }) => {

                    this.profissional = data

                    if (this.profissional.length === 0) {

                        this.agendamento.profissionalId = null
                    }

                    if (this.isFromRegulacao) {

                        if (this.profissional.length === 0) {

                            this.showWarningNotification('Não há nenhum usuário executante para o prestador do exame regulado.')
                        }
                    } else {

                        if (!this.agendamento.profissionalId) {

                            const profissionalId = this.profissional.length === 1 ? this.profissional[0].profissionalId : null

                            this.agendamento.profissionalId = profissionalId

                        }
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setMedico(){
            this.medico = { medico: null }
        },
        setAgendamento(){
            this.agendamento = {
                alterar: false,
                retroativo: false,
                agendamentoId: null,
                agendamentoNumero: '',
                data: null,
                dataTradada: null,
                dataMenstruacao: null,
                grupoExameId: null,
                grupoExameNome: '',
                exames: [],
                gestante: false,
                impressao: true,
                horaInicial: null,
                horaExame: '',
                infraestruturaId: null,
                infraestruturaNome: '',
                jornadaId: null,
                controleJornadaId: null,
                unidadeId: null,
                unidadeSolicitanteId: null,
                unidadeLogadaNome:'',
                infraestruturaSolicitanteId: null,
                infraestruturaSolicitanteNome: '',
                unidadeNome: '',
                profissionalNome: '',
                profissionalId: null,
                prestadorId: null,
                unidadeDisabled: false,
                usuarioId: '',
                usuarioNome: '',
                selecionado: false,
                statusId: null,
                urgente: false,
                pacienteId: '',
                observacao: '',
                sexoId: '',
                medicoSolicitante: null,
                medicoNome: '',
                medicoId: null,
                nomeResponsavel: '',
                incluido:[],
                supervisorId: null,
                agendadorId: null,
            }

            this.agendamento.nomeResponsavel = this.form.paciente.cidadao.nomeMae
            this.agendamento.unidadeSolicitanteId  = this.form.unidadeLogada
            this.agendamento.infraestruturaSolicitanteId  = this.form.localAtendimentoLogado

            this.vagas = [],
            this.horaSave = null,
            this.loadDays()
        },
        continueAgendamento() {

            this.agendamento.alterar = false
            this.agendamento.retroativo = false
            this.agendamento.agendamentoId = null
            this.agendamento.agendamentoNumero = ''
            this.agendamento.data = null
            this.agendamento.dataTradada = null
            this.agendamento.dataMenstruacao = null
            this.agendamento.grupoExameId = null
            this.agendamento.grupoExameNome = ''
            this.agendamento.exames = []
            this.agendamento.impressao = true
            this.agendamento.horaInicial = null
            this.agendamento.horaExame = ''
            this.agendamento.jornadaId = null
            this.agendamento.controleJornadaId = null
            this.agendamento.selecionado = false
            this.agendamento.statusId = null
            this.agendamento.urgente = false
            this.agendamento.observacao = ''
            this.agendamento.nomeResponsavel = ''
            this.agendamento.incluido = []
            this.agendamento.supervisorId = null
            this.agendamento.agendadorId = null
            this.agendamento.prestadorId = null,
            this.agendamento.profissionalId = null,

            this.examesAmbulatorio = []
            this.multipleExamesAmbulatorio = false

            this.index = null
            this.vagas = []
            this.horaSave = null

            this.load()
            this.$refs.TabAgendarExames.resetValidate()

            this.$nextTick(() => this.$refs.TabAgendarExames.openModalExameAmbulatorio())
        },
        setActive(){

            this.setAgendamento()
            this.setMedico()
            this.index = null
        },
        handleClassificacaoBloqueada(paciente) {

            const mensagem = `O cadastro selecionado possui a classificação ${paciente.classificacao} e não pode
                seguir com o agendamento do exame. Atualize o cadastro.`

            const sair = async () => {

                this.$emit('handleExitPaciente')
            }

            const podeAtualizarClassificacao = this.additionals.permiteAtualizarCadastroPaciente === true
                && this.verificarPermissao('update-cadastro-paciente')

            if (!podeAtualizarClassificacao) {

                this.showWarningNotification(mensagem, sair)

                return
            }

            const atualizarClassificacao = async () => {

                this.$emit('handleAtualizaPaciente')
            }

            this.showWarningConfirmation(
                'Atenção',
                mensagem,
                atualizarClassificacao,
                sair,
                null,
                'Atualizar classificação',
                'Sair'
            )
        },
        loadPaciente(paciente, exibirExameAmbulatorioAtendimento) {

            if (this.additionals.agendamentoClassificacaoBloqueado) {

                this.handleClassificacaoBloqueada(paciente)

                return false
            }

            if(!paciente.unidade){

                const confirm = async () => {

                    this.$emit('handleAtualizaPaciente')
                }

                const cancel = async () => {

                    this.$emit('handleExitPaciente')
                }

                const msg = 'Algumas informações do(a) paciente estão com erro ou desatualizadas. ' +
                    'Para realizar o agendamento é necessário atualiza-lo. Deseja atualizar?'

                    this.showConfirmation(msg, confirm, cancel)

                return false

            } else {

                this.paciente.id = paciente.id
                this.paciente.nome = paciente.cidadao.nome
                this.paciente.preferenciaNomeId = paciente.cidadao.preferenciaNomeId
                this.paciente.nomeSocial = paciente.cidadao.nomeSocial
                this.paciente.prontuario = paciente.prontuario
                this.paciente.cpf = paciente.cidadao.cpf
                this.paciente.cns = paciente.cidadao.cns
                this.paciente.telefone =  paciente.cidadao.telefonePrincipal?.numero
                this.paciente.dataNascimento = paciente.cidadao.dataNascimento
                this.paciente.idade = paciente.cidadao.idade
                this.paciente.anos = paciente.cidadao.idade.anos
                this.paciente.meses = paciente.cidadao.idade.meses
                this.paciente.dias = paciente.cidadao.idade.dias
                this.paciente.sexo = paciente.cidadao.sexo
                this.paciente.sexoId = paciente.cidadao.sexo.id
                this.paciente.sexoDescricao = paciente.cidadao.sexo.descricao
                this.paciente.nomeMae = paciente.cidadao.nomeMae
                this.paciente.unidadeReferencia = paciente.unidade.nomeFantasia

                if (!paciente.cidadao.cpf || !paciente.cidadao.cns || !paciente.cidadao?.telefones ||
                    !paciente.cidadao.dataNascimento || !paciente.cidadao.sexo.id ||
                    (!paciente.cidadao.desconheceNomeMae && !paciente.cidadao.nomeMae)) {

                    const confirm = async () => {

                        this.$emit('handleAtualizaPaciente')
                    }

                    const cancel = async () => {

                        this.$emit('handleExitPaciente')
                    }

                    const msg = 'O cadastro do paciente está incompleto. Para realizar o agendamento é necessário' +
                        ' atualiza-lo. Deseja atualizar?'

                        this.showConfirmation(msg, confirm, cancel)

                    return false
                }
            }

            this.form.exibirExameAmbulatorioAtendimento = exibirExameAmbulatorioAtendimento
        },
        saveModal(supervisorId) {

            this.agendamento.supervisorId = supervisorId
            this.save()
        },
        save(){

            if (this.saving) return
            this.saving = true

            if(this.tabIndex == 0){

                this.$refs.TabAgendarExames.validate()
                    .then(valid => {

                        if (!valid || !this.validateFields()) {
                            this.saving = false
                            return
                        }

                        this.setLoading()

                        this.repositories.agendamento.store(this.prepareData())
                            .then(({ data }) => {

                                if (data.requiresSupervisor || data.requiresSupervisorJornada) {

                                    let msg;

                                    if (data.requiresSupervisorJornada) {

                                        msg = `Para prosseguir com o agendamento, é necessário informar os dados do
                                            supervisor, pois o número de agendamentos excedeu as vagas disponíveis para a
                                            jornada. Deseja continuar?`;
                                    } else {

                                        msg = `Para prosseguir com o agendamento, é necessário informar os dados do
                                            supervisor, pois a cota para o período foi ultrapassada. Deseja continuar?`;
                                    }

                                    this.showAlert(msg, 'Atenção');

                                    this.showConfirmation(msg, async () => {
                                        this.$refs.ModalSupervisor.open();
                                    });

                                    return false;
                                } else {

                                    if (this.isFromRegulacao) {

                                        this.handlePrint(data.impressaoAgendamentoNumero, data.regulacaoMensagemComprovanteAgendamento)

                                        data.agendamentoAtual = this.clone(this.agendamento)

                                        this.$emit('save', data)
                                    } else {

                                        this.showSaveNotification()

                                        this.handlePrint(data.impressaoAgendamentoNumero, data.regulacaoMensagemComprovanteAgendamento)

                                        data.agendamentoAtual = this.clone(this.agendamento)

                                        this.showConfirmation("Deseja agendar um novo exame para o mesmo paciente?",
                                            async () => this.continueAgendamento(),
                                            async () => this.$emit('save', data)
                                        )
                                    }
                                }
                            })
                            .catch(this.handleError)
                            .finally(() => {
                                this.saving = false
                                this.unsetLoading()
                            })
                    })
                    .catch(error => {
                        this.saving = false
                        this.handleError(error)
                    })
            } else {

                this.setLoading()

                this.repositories.agendamento.store(this.prepareData())
                    .then(({ data }) => {

                        if (data.requiresSupervisor || data.requiresSupervisorJornada) {

                            let msg;

                            if (data.requiresSupervisorJornada) {

                                msg = `Para prosseguir com o agendamento, é necessário informar os dados do
                                    supervisor, pois o número de agendamentos excedeu as vagas disponíveis para a
                                    jornada. Deseja continuar?`;
                            } else {

                                msg = `Para prosseguir com o agendamento, é necessário informar os dados do
                                    supervisor, pois a cota para o período foi ultrapassada. Deseja continuar?`;
                            }

                            this.showAlert(msg, 'Atenção');

                            this.showConfirmation(msg, async () => {
                                this.$refs.ModalSupervisor.open();
                            });

                            return false;
                        } else {

                            this.showSaveNotification()

                            if (this.isFromRegulacao) {

                                data.agendamentoAtual = this.clone(this.agendamento)

                                this.$emit('save', data)
                            } else {

                                this.$nextTick().then(() =>

                                    this.showConfirmation("Deseja agendar um novo exame para o mesmo paciente?",
                                        async () => this.continueAgendamento(),
                                        async () => this.$emit('save', data)
                                    )
                                )
                            }
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => {
                        this.saving = false
                        this.unsetLoading()
                    })
            }
        },
        handlePrint(agendamentoNumero, regulacaoMensagemComprovanteAgendamento) {

            var executantePrincipal = this.form.unidadeExecutante.find(u => u.unidadeId === this.agendamento.unidadeId)

            var  infraestruturaPrincipal = executantePrincipal.infraestruturas.find(f => f.infraestruturaId === this.agendamento.infraestruturaId)

            let agendamento = {
                pacienteNome: this.form.paciente.cidadao.nome,
                nomeSocial: this.form.paciente.cidadao.nomeSocial,
                prontuario: this.form.paciente.prontuario,
                nomeResponsavel: this.agendamento.responsavel,
                dataNascimento: this.form.paciente.cidadao.dataNascimento.split("-").reverse().join("/"),
                agendamentoNumero: agendamentoNumero,
                medicoNome: this.agendamento.medicoSolicitante.cidadaoNome,
                observacao: this.agendamento.observacao,
                profissionalNome: this.agendamento.profissionalNome,
                grupoExameNome: this.agendamento.exameNome,
                unidadeSolicitante: this.form.unidadeLogadaNome,
                data: moment(this.agendamento.data).format('DD/MM/YYYY'),
                examesIncluido: this.agendamento.incluido,
                horaExame: this.agendamento.horaExame,
                logotipo: this.form.cliente.logotipo,
                nomePrefeitura: this.form.cliente.nome,
                ramoAtividade: this.form.cliente.sistema.ramoAtividade.nome,
                mensagemProtocolo: this.form.mensagemProtocolo,
                sistemaNome: this.form.cliente.sistema.nome,
                sistemaVersao: this.form.cliente.sistema.versao,
                usuario: this.form.usuario,
                usuarioNomeSocial: this.form.usuarioNomeSocial ? this.form.usuarioNomeSocial : null,
                urgente: this.agendamento.urgente,
                unidadeExecutante: this.agendamento.unidadeNome,
                enderecoExecutante: infraestruturaPrincipal.endereco,
                numeroEnderecoExecutante: infraestruturaPrincipal.numeroEndereco,
                bairroExecutante: infraestruturaPrincipal.bairro,
                telefoneExecutante: infraestruturaPrincipal.telefone,
                regulacaoMensagemComprovanteAgendamento: this.isFromRegulacao
                    ? regulacaoMensagemComprovanteAgendamento
                    : null,
                regulacaoProtocoloFechamento: this.isFromRegulacao
                    ? this.regulacaoSolicitacao.numero
                    : null,
            }

            this.print().agendamento(agendamento)
        },
        prepareData() {

            const agendamentoNovo = this.clone(this.agendamento)

            if(agendamentoNovo.jornadaId !== null){

                agendamentoNovo.unidadeSolicitanteId = this.form.unidadeLogada
                agendamentoNovo.infraestruturaSolicitanteId = this.form.localAtendimentoLogado

                agendamentoNovo.medicoId = agendamentoNovo.medicoSolicitante.id
                agendamentoNovo.medicoNome = agendamentoNovo.medicoSolicitante.cidadaoNome
                    || agendamentoNovo.medicoSolicitante.nome

                agendamentoNovo.dataMenstruacao = this.getFormatedDate(agendamentoNovo.dataMenstruacao, 'DD/MM/YYYY')
                agendamentoNovo.agendamentoNumero = new Date().getTime()
                agendamentoNovo.regulacaoSolicitacaoId = this.regulacaoSolicitacao?.id ?? null

                if (agendamentoNovo.agendamentoId == null) {

                    const uniqueId = this.uniqueId('agendamento' + new Date().getTime())

                    agendamentoNovo.agendamentoId = uniqueId
                    this.agendamento.agendamentoId = uniqueId

                    this.model.agendamentos.push(agendamentoNovo)

                } else {

                    const objIndex = this.model.agendamentos.findIndex((obj =>
                        obj.agendamentoId == agendamentoNovo.agendamentoId
                    ));

                    this.$set(this.model.agendamentos, objIndex, this.clone(agendamentoNovo))
                }
            }

            this.model.pacienteId = this.form.paciente.id
            this.model.telefone = {
                id: this.form.paciente.telefoneId,
                numero: (this.form.paciente.telefoneNumero || '').replace(/\D/g, ''),
                autorizaSms: this.form.paciente.telefoneAutorizaSms,
                atualizado: this.form.paciente.telefoneAtualizado,
            }

            return this.camelObjectKeysToSnakeRecursive(this.model)
        },
        handleAlter(item, index ) {

            this.model.agendamentos.filter(obj => obj.agendamentoId == item.agendamentoId)
                .forEach(exameIncluido => {

                    exameIncluido.incluido = exameIncluido.incluido.filter(item => item.statusId !== this.enums.status.CANCELADO);

                    if(exameIncluido.incluido.find(m => m.statusId == this.enums.status.REALIZADO
                        || m.statusId == this.enums.status.FALTOU || m.faturamento)){

                        this.showValidationNotification(`Não é possível realizar a alteração desse agendamento,
                            pois há um ou mais exames realizados, faturados ou com ausência do paciente registrada.`)

                    } else {

                        this.agendamento = item

                        this.agendamento.medicoSolicitante = {
                            id: item.medicoSolicitante.id,
                            cidadaoNome: item.medicoSolicitante.cidadaoNome || item.medicoSolicitante.nome,
                            nome: item.medicoSolicitante.nome || item.medicoSolicitante.cidadaoNome,
                        }

                        this.index = index

                        this.agendamento.alterar = true
                        this.agendamento.impressao = true

                        this.tabIndex = 0
                        this.horaSave = item.horaExame

                        this.examesAmbulatorio = []
                        this.multipleExamesAmbulatorio = false
                    }
                })
        },
        loadVagas() {

            this.vagas = []
            this.jornadas = []

            if (!this.agendamento.profissionalId || !this.agendamento.grupoExameId) {

                this.vagas = []
                this.jornadas = []

                return
            }

            this.setLoading()

            this.repositories.agendamento.getJornadas({
                unidade_id: this.agendamento.unidadeId,
                infraestrutura_id: this.agendamento.infraestruturaId,
                exame_id: this.agendamento.grupoExameId,
                profissional_id: this.agendamento.profissionalId,
            })
            .then(response => {

                this.vagas = response.data.agendamentos
                this.jornadas = response.data.jornadas
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading(this.$nextTick(() => this.alterCalendar(this.agendamento.data))))
        },
        alterCalendar(data){

            let diasCalendario = []

            let dataAtual = this.form.dataAtual
            dataAtual = dataAtual.split("/").reverse().join("-")

            if (this.jornadas.length == 0) {

                this.showValidationNotification(`Não existe jornada cadastrada para o profissional selecionado.`)

                return false
            }

            this.jornadas.filter(u => u.profissionalId === this.agendamento.profissionalId
                && u.exameId === this.agendamento.grupoExameId && u.unidadeId === this.agendamento.unidadeId)
                .map(unidade => {

                    const feriado = this.form.feriados.find(feriado => feriado.data === unidade.data
                        && (feriado.abrangencia === this.enums.abrangencia.TODAS || feriado.infraestruturaIds.includes(unidade.infraestruturaId))
                    );
                    const isFeriado = !!feriado;

                    if (isFeriado) {
                        diasCalendario.push({
                            'dates': moment(unidade.data, 'DD/MM/YYYY').toDate(),
                            'highlight': 'yellow',
                            'title': feriado.tipoNome,
                            'popover': feriado.observacao,
                            'clickable': false
                        });
                    }

                    let vagas = this.loadQuantidadeVagas(unidade);

                    if (moment(unidade.data.split("/").reverse().join("-")).isSameOrAfter(dataAtual)) {

                        if (data && data == unidade.data.split("/").reverse().join("-")) {

                            let calendarioTitle = !this.horaSave ? `${this.getJornada(unidade) + 1}/${vagas}` : `${this.getJornada(unidade)}/${vagas}`

                            diasCalendario.push({
                                'dates': data.split("-").reverse().join("/"),
                                'title': calendarioTitle,
                                'highlight': 'blue',
                            })
                        } else {

                            if(this.getJornada(unidade) >= vagas){
                                diasCalendario.push({
                                    'dates': moment(unidade.data, 'DD/MM/YYYY').toDate(),
                                    'title': `${this.getJornada(unidade)}/${vagas}`,
                                    'highlight': 'red',
                                })
                            } else {
                                diasCalendario.push({
                                    'dates': moment(unidade.data, 'DD/MM/YYYY').toDate(),
                                    'title': `${this.getJornada(unidade)}/${vagas}`,
                                    'highlight': unidade.statusId === this.enums.statusJornada.ATIVO ? 'green' : 'gray',
                                    'popover':  unidade.statusNome
                                })
                            }
                        }

                    } else {

                        if (data && data == unidade.data.split("/").reverse().join("-")) {
                            diasCalendario.push({
                                'dates': data.split("-").reverse().join("/"),
                                'title': `${this.getJornada(unidade) + 1}/${vagas}`,
                                'highlight': 'blue',
                            })
                        } else {
                            diasCalendario.push({
                                'dates': moment(unidade.data, 'DD/MM/YYYY').toDate(),
                                'title': `${this.getJornada(unidade)}/${vagas}`,
                                'highlight': 'gray',
                                'fillMode': 'light',
                            })
                        }
                    }

            })

           this.form.feriados
                .filter(feriado => feriado.abrangencia === this.enums.abrangencia.TODAS
                    || feriado.infraestruturaIds.includes(this.agendamento.infraestruturaId))
                .map(feriado => {

                    diasCalendario.push({
                        'dates': moment(feriado.data, 'DD/MM/YYYY').toDate(),
                        'highlight': 'yellow',
                        'title': feriado.tipoNome,
                        'popover': feriado.observacao,
                        'clickable': false
                    });

                });

            this.diasCalendario = diasCalendario
        },
        getJornada(agendamento) {

            let vagasPreenchidas = 0

            if(agendamento.controleJornadaId == this.enums.tipoControleJornada.EXAME){

                this.vagas.filter(item => item.data === agendamento.data)
                    .map(exameIncluido => {

                        vagasPreenchidas = vagasPreenchidas + exameIncluido.incluido.length
                    })

                    return vagasPreenchidas

            } else {

                vagasPreenchidas = this.vagas.filter(item => item.data === agendamento.data).length;

                return vagasPreenchidas
            }
        },
        loadQuantidadeVagas(unidade) {

            let quantidade = this.jornadas.filter(item => item.data === unidade.data
                && item.profissionalId === this.agendamento.profissionalId
                && item.exameId === this.agendamento.grupoExameId
                && item.unidadeId === this.agendamento.unidadeId
            )
                .reduce((sum, element) => {

                    if (element.vagas) {
                        sum = sum + Number(element.vagas) + Number(element.vagasApp || 0);
                    }

                    return sum;
                },0)

            return quantidade
        },
        resetProfissional(){

            this.agendamento.profissionalId = null
            this.loadDays()
        },
        resetGrupoExame(){

            this.agendamento.grupoExameId = null
            this.loadDays()
        },
        validateFields() {

            if (this.agendamento.data === null) {

                this.showValidationNotification('Obrigatório selecionar uma data.')
                return false
            }

            if (this.agendamento.horaExame === null) {

                this.showValidationNotification('Obrigatório selecionar um horário.')
                return false
            }

            if (this.agendamento.incluido.length == 0) {

                this.showValidationNotification('Obrigatório atribuir pelo menos um exame no agendamento.')
                return false
            }

            return true
        },
        validate() {
            return this.tabRefs[this.tabIndex].validate()
        },
        loadDays() {

            let diasCalendario = []

            this.form.feriados
                .filter(feriado => feriado.abrangencia === this.enums.abrangencia.TODAS
                    || feriado.infraestruturaIds.includes(this.agendamento.infraestruturaId))
                .map(feriado =>

                diasCalendario.push({
                    'dates': moment(feriado.data, 'DD/MM/YYYY').toDate(),
                    'highlight': 'yellow',
                    'title': feriado.tipoNome,
                    'popover':  feriado.observacao
                })

            )

            this.loadDiasCalendario(diasCalendario)
        },
        loadDiasCalendario(value) {

            this.diasCalendario = value
        },
        multipleAmbulatorioAtendimento(examesSelecionados) {

            const exames = examesSelecionados.filter(exame => exame.selecionado);

            if (exames.length > 1) {

                this.multipleExamesAmbulatorio = true
            }

            this.setExamesAmbulatorio(exames)
        },
        agendarAmbulatorioAtendimento(item) {

            this.setExamesAmbulatorio([item])
        },
        setExamesAmbulatorio(itens) {

            this.agendamento.medicoSolicitante = {
                id: itens[0].profissionalId,
                cidadaoNome: itens[0].profissionalNome,
            }

            if (this.agendamento.infraestruturaId) {

                this.loadGrupo()
            }

            this.examesAmbulatorio = itens
        }
    },
    mixins: [formats, permissao, repository, stringCase, object, error, data, printExameImagem],
    props: {
        id: { type: Number },
        hideAgendamentos: { type: Boolean, default: false },
        regulacaoSolicitacao: { type: Object },
    },
}
</script>

<style>
.tabs {
    border: 0px solid #dee2e6!important;
    border-radius: 0.25rem;
}
</style>